import type { MouseEvent } from "react";
import {
  openLegalDoc,
  TLegalDoc,
} from "../../Orchestrator/Recoils/LegalDocModalAtom";

/**
 * Anchor onClick helper: opens the legal popup on a plain left-click but
 * leaves modified clicks (ctrl/cmd/shift -> new tab) to the browser so the
 * real page stays reachable.
 */
export const openLegalDocFromClick = (e: MouseEvent, doc: TLegalDoc): void => {
  if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
  e.preventDefault();
  openLegalDoc(doc);
};

/**
 * Appends the active locale as a `lang` query param to an internal legal-page
 * route. The web pages derive their locale from the cookie and ignore this
 * param, but the mobile WebView reads it to open the page in the right
 * language (e.g. /terms-and-conditions?tab=privacy-policy&lang=ar). A plain
 * left-click on web still opens the in-app modal; this only shapes the real
 * navigable href (new-tab on web, mobile).
 */
export const withLangParam = (path: string, locale: string): string =>
  `${path}${path.includes("?") ? "&" : "?"}lang=${locale}`;
